var map = {
	"./FORGE_ONGOING_A.mp4": 44435,
	"./FORGE_ONGOING_B_BLUE.mp4": 58122,
	"./FORGE_ONGOING_B_GREEN.mp4": 76711,
	"./FORGE_ONGOING_B_PURPLE.mp4": 30506,
	"./FORGE_ONGOING_B_WHITE.mp4": 6209,
	"./FORGE_SUCCESS_BLUE.mp4": 48802,
	"./FORGE_SUCCESS_GREEN.mp4": 80312,
	"./FORGE_SUCCESS_ORANGE.mp4": 61523,
	"./FORGE_SUCCESS_PURPLE.mp4": 34244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28364;